import React, { memo, useCallback, useContext, useMemo, useState } from 'react'

import {
  Button,
  ClosingDropdown,
  Icon,
  ChevronDown,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSize, iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import SoftwareIcon from 'Pods/ThreeDStudio/Shared/SoftwareIcon/SoftwareIcon'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import DccBridgePopover from '../DccBridgePopover/DccBridgePopover'

const dccLabelFallback = 'DCC'

const trailIcon = (
  <span className="dcc-bridge-cluster__chevron">
    <Icon svgComponent={ChevronDown} color="dark" size={iconSize} notSpaced />
  </span>
)

function DccBridgeButton() {
  const { dccSoftwares: softwares } = useContext(ThreeDStudioPageContext)
  const selectedName = useThreeDStudioStore(state => state.dccBridge.selectedSoftwareName)

  const [triggerCloseDropdown, setTriggerCloseDropdown] = useState(false)
  const handleClosePopover = useCallback(() => {
    setTriggerCloseDropdown(true)
  }, [])

  const hasAnyEnabled = useMemo(
    () => softwares.some(s => s.isEnabled),
    [softwares]
  )
  const selectedSoftware = useMemo(
    () => softwares.find(s => s.name === selectedName) || null,
    [softwares, selectedName]
  )

  const buttonLabel = selectedSoftware ? selectedSoftware.name : dccLabelFallback
  const leadIcon = selectedSoftware
    ? <SoftwareIcon iconName={selectedSoftware.iconName} size={iconSizeMedium} />
    : null

  return (
    <ClosingDropdown
      content={(
        <DccBridgePopover
          softwares={softwares}
          selectedName={selectedName}
          onClosePopover={handleClosePopover}
        />
      )}
      isSimpleContent
      size="medium"
      placement="top-end"
      contentClassName="dcc-bridge-popover-wrap"
      className="dcc-bridge-cluster__dcc-wrap"
      usePortal
      triggerCloseDropdown={triggerCloseDropdown}
      setTriggerCloseDropdown={setTriggerCloseDropdown}
    >
      <Button
        icon={leadIcon}
        trailIcon={trailIcon}
        type="secondary"
        size="small"
        variant={leadIcon ? 'with-icon' : undefined}
        aria-label={selectedSoftware ? `DCC Bridge (${selectedSoftware.name})` : 'DCC Bridge'}
        disabled={!hasAnyEnabled}
        customClass="dcc-bridge-cluster__dcc"
      >
        {selectedSoftware ? null : buttonLabel}
      </Button>
    </ClosingDropdown>
  )
}

export default memo(DccBridgeButton)
